import axiosClient from '../configs/axios';


class deliveryEntryService {
     
   async getDeliveryEntryList(params) {
    try {
        const depotId = sessionStorage.getItem('depot_id');
        const response = await axiosClient.get(
            `/deliveryentry/list?page=${params.page}&&size=${params.size}&&searchKey=${params.searchKey}&&depot_id=${depotId}`
        );
        return response.data;
    } catch (error) {
        throw error;
    }
}
     
    async addDeliveryEntry(data) {
        try {
            const response = await axiosClient.post('/deliveryentry/add', data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    
    async editDeleteDeliveryEntry(data) {
        try {
            const response = await axiosClient.put(`/deliveryentry/editDelete`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export default new deliveryEntryService(); 